import React from "react";
import styled from "styled-components";
import { flexbox, space } from "styled-system";
import { Base } from "../../styles";
const CardWrapper = styled(Base)`
  display: inline-block;
  width: 100%;
  max-width: 380px;
  height: max-content;
`;
const OuterCardWrapper = styled(Base)({
  width: "100%",
  maxWidth: "1115px",
  margin: "0 auto",
  display: "flex",
  alignItems: "center"
}, flexbox, space);
const SeriesCTAGrid = ({ children, copySide }) => {
  const justifyContent = copySide === "right" ? ["flex-start", "flex-end", "flex-end"] : ["flex-start", "flex-start", "flex-start"];
  return /* @__PURE__ */ React.createElement(OuterCardWrapper, {
    as: "div",
    justifyContent,
    height: [
      "calc(100vh - 58px)",
      "calc(100vh - 58px)",
      "calc(100vh - 104px)"
    ]
  }, /* @__PURE__ */ React.createElement(CardWrapper, {
    as: "div"
  }, children));
};
export default SeriesCTAGrid;
